import { render } from "./AkTinyMCE.vue?vue&type=template&id=dee775a2"
import script from "./AkTinyMCE.vue?vue&type=script&lang=js"
export * from "./AkTinyMCE.vue?vue&type=script&lang=js"

import exportComponent from "/root/dirif/preprod/dirif-fo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__